var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Box } from "@material-ui/core";
import React from "react";
var TabPanel = function (props) {
    var children = props.children, value = props.value, index = props.index, remount = props.remount, rest = __rest(props, ["children", "value", "index", "remount"]);
    var _a = React.useState(false), isDisplayed = _a[0], setIsDisplayed = _a[1];
    React.useEffect(function () {
        if (!isDisplayed && value === index) {
            setIsDisplayed(true);
        }
    }, [value, index]);
    return remount ? (index == value ? (React.createElement(Box, __assign({}, rest, { width: "100%" }), children)) : (React.createElement(Box, null))) : (React.createElement(Box, __assign({}, rest, { display: index == value ? "block" : "none", width: "100%" }), isDisplayed && children));
};
export default React.memo(TabPanel);
